export const themeColors = {
    TEAL: {
        primary: "#006d77",
        primaryHover: "#00565e",
        secondary: "#146d88",
        secondaryHover: "#0d5a71",
        accent: "#83c5be",
        light: "#edf6f9",
        background: "#f0fdfa",
    },
    BLUE: {
        primary: "#1d4ed8",
        primaryHover: "#1e40af",
        secondary: "#3b82f6",
        secondaryHover: "#2563eb",
        accent: "#93c5fd",
        light: "#eff6ff",
        background: "#f0f7ff",
    },
    GREEN: {
        primary: "#15803d",
        primaryHover: "#166534",
        secondary: "#22c55e",
        secondaryHover: "#16a34a",
        accent: "#86efac",
        light: "#f0fdf4",
        background: "#f0fff4",
    },
    RED: {
        primary: "#b91c1c",
        primaryHover: "#991b1b",
        secondary: "#ef4444",
        secondaryHover: "#dc2626",
        accent: "#fca5a5",
        light: "#fef2f2",
        background: "#fff1f1",
    },
    PURPLE: {
        primary: "#7e22ce",
        primaryHover: "#6b21a8",
        secondary: "#a855f7",
        secondaryHover: "#9333ea",
        accent: "#d8b4fe",
        light: "#faf5ff",
        background: "#f5f3ff",
    },
    INDIGO: {
        primary: "#4338ca",
        primaryHover: "#3730a3",
        secondary: "#6366f1",
        secondaryHover: "#4f46e5",
        accent: "#a5b4fc",
        light: "#eef2ff",
        background: "#f5f7ff",
    },
    ORANGE: {
        primary: "#c2410c",
        primaryHover: "#9a3412",
        secondary: "#f97316",
        secondaryHover: "#ea580c",
        accent: "#fdba74",
        light: "#fff7ed",
        background: "#fffaf0",
    },
    NAVY: {
        primary: "#1e3a8a",
        primaryHover: "#172554",
        secondary: "#1e40af",
        secondaryHover: "#1d4ed8",
        accent: "#60a5fa",
        light: "#f0f4ff",
        background: "#f5f9ff",
    }
};
